(function(window,$,Hammer,Modernizr) {

	if (!Modernizr.flexbox) {
		normalizeWhereToDownload();
		$(window).on('load resize orientationchange', function() {
			normalizeWhereToDownload();
		});
	}

	function normalizeWhereToDownload() {
		$('.app_everest-headphones, .app_download-cta').removeAttr('style');
		if ($(window).width() >= 832) {
			var appEverestHeadphonesHeight = $('.app_everest-headphones').outerHeight(true),
				appDownloadCtaHeight = $('.app_download-cta').outerHeight(true),
				largestHeight = Math.max(appEverestHeadphonesHeight, appDownloadCtaHeight);
			$('.app_everest-headphones, .app_download-cta').css({'height': largestHeight+'px'});
		}
	}

	$.fn.visible = function() {
		var viewTop = $(window).scrollTop(),
			viewBottom = viewTop + $(window).height(),
			_top = $(this).offset().top;
		return _top <= viewBottom;
	};

	var selectors = {
		item: '.app_carousel-item',
		active: '.app_active'
	};

	$(window).on('load', function() {
		var features = new Features($('.app_features-carousel'));
		features.init();
	});

	function Features(element) {

		var self = this,
			_items = $(selectors.item, element),
			_activeIndex = $(selectors.item + selectors.active, element).index(),
			_autoRotateInterval,
			_waitTimeout,
			_hasStarted = false;

		self.init = function() {

			if ( $(window).width() < 1101 ) {
				var elements = document.getElementsByClassName('app_features-carousel');
				var hammertime = new Hammer(elements[0]);
				hammertime.on('swipeleft swiperight', function(event) {
					switch(event.type) {
						case 'swipeleft':
							if (_activeIndex === _items.length-1) return;
							clearTimeout(_waitTimeout);
							clearInterval(_autoRotateInterval);
							_hasStarted = true;
							self.showItem(_activeIndex+1);
							if ( $(window).width() >= 832 ) {
								_autoRotateInterval = setInterval(function(){
									self.showItem(_activeIndex+1);
								}, 5000);
							}
						break;
						case 'swiperight':
							if (_activeIndex === 0) return;
							clearTimeout(_waitTimeout);
							clearInterval(_autoRotateInterval);
							_hasStarted = true;
							self.showItem(_activeIndex-1);
							if ( $(window).width() >= 832 ) {
								_autoRotateInterval = setInterval(function(){
									self.showItem(_activeIndex+1);
								}, 5000);
							}
						break;
					}
				});
			}

			_normalizeHeight();
			$(window).on('load resize orientationchange', function() {
				_normalizeHeight();
			});

			$(window).on('resize', function() {
				_restartCarousel();
				_hasStarted = true;
			});

			$('.app_features .app_text').each(function(i, el) {
				if ( $(el).visible() ) {
					$(el).addClass('already-visible');
					$('.app_rings').addClass('already-visible');
					if ( !_hasStarted ) {
						_restartCarousel();
						_hasStarted = true;
					}
				}
			});

			$(window).on('scroll resize orientationchange', function() {
				$('.app_features .app_text').each(function(i, el) {
					if ( $(el).visible() ) {
						$(el).addClass('come-in');
						$('.app_rings').addClass('come-in');
						if ( !_hasStarted ) {
							_restartCarousel();
							_hasStarted = true;
						}
					}
				});
			});

			$('.app_carousel-pagination button').click(function() {
				clearTimeout(_waitTimeout);
				clearInterval(_autoRotateInterval);
				if ( !$(this).hasClass(selectors.active) ) {
					var index = $(this).index();
					self.showItem(index);
				}
				if ( $(window).width() >= 832 ) {
					_hasStarted = true;
					_waitTimeout = setTimeout(function(){
						_autoRotateInterval = setInterval(function() {
							self.showItem(_activeIndex+1);
						}, 5000);
					},10000);
				}
			});

			$('.app_features-nav button').click(function() {
				if ( $(window).width() < 832 ) return;
				clearTimeout(_waitTimeout);
				clearInterval(_autoRotateInterval);
				if ( !$(this).hasClass('app_active') ) {
					var index = $(this).index();
					self.showItem(index);
				}
				_hasStarted = true;
				_waitTimeout = setTimeout(function(){
					_autoRotateInterval = setInterval(function() {
						self.showItem(_activeIndex+1);
					}, 5000);
				},10000);
			});

		};

		function _wrapIndex(index) {
			if (index < 0) {
				index = _items.length-1;
			} else if (index > _items.length-1) {
				index = 0;
			}
			return index;
		}

		self.showItem = function(index) {
			index = _wrapIndex(index);
			if ( index == _activeIndex ) { return; }

			var _previousIndex = _activeIndex;
			_activeIndex = index;
			var _nextIndex = _wrapIndex(_activeIndex+1);

			$('.app_carousel-item, .app_iphone-screenshot').removeClass('app_left app_right');
			$('.app_carousel-item').each(function(i) {
				if (i == _activeIndex) return;
				var directionClass = i < _activeIndex ? 'app_left' : 'app_right';
				$(this).addClass(directionClass);
				$('.app_iphone-screenshot').eq(i).addClass(directionClass);
			});

			$('.app_carousel-item.app_previous, .app_iphone-screenshot.app_previous').removeClass('app_previous');
			$('.app_carousel-item.app_active, .app_iphone-screenshot.app_active').addClass('app_previous').removeClass('app_active');
			$('.app_carousel-item').eq(_activeIndex).addClass('app_active');
			$('.app_iphone-screenshot').eq(_activeIndex).addClass('app_active');

			_updateNavigation();
		};

		self.nextItem = function() {
			return self.showItem(_activeIndex+1);
		};

		self.previousItem = function() {
			return self.showItem(_activeIndex-1);
		};

		function _restartCarousel() {
			clearTimeout(_waitTimeout);
			clearInterval(_autoRotateInterval);
			if ( $(window).width() >= 832 ) {
				_autoRotateInterval = setInterval(function(){
					self.showItem(_activeIndex+1);
				}, 5000);
			}
		}

		function _updateNavigation() {
			$('.app_features-nav button')
				.removeClass('app_active')
				.eq(_activeIndex)
				.addClass('app_active');
			$('.app_carousel-pagination button')
				.removeClass('app_active')
				.eq(_activeIndex)
				.addClass('app_active');
		}

		function _normalizeHeight() {
			$('.app_carousel-item').removeAttr('style');
			var height,
				largestHeight = 0;
			$('.app_carousel-item').each(function() {
				var itemHeight = $(this).outerHeight(true);
				if ( itemHeight > largestHeight ) largestHeight = itemHeight;
			});
			height = largestHeight;
			$('.app_carousel-item').css('height', height+'px');
		}

	}

})(window,jQuery,Hammer,Modernizr);
